<template>
  <div class="my-2" style="min-height:100%">
      <div class="px-md-2 d-flex flex-row flex-coluna">
        <card class="col-lg-9 col-sm-8 col-md-8 flex-coluna"
              body-classes="p-0"
              style="max-width: 100vw;">
          <template slot="header">
            <h4 class="card-title padding-sm">{{ cliente }}</h4>
            <p class="card-category padding-sm float-left">
              Tabela de pendências
                 <p class="card-category padding-sm float-right">
                    <i class="fa fa-clock-o"></i>
                    Última Atualização {{ ultimoSyncLojas }}
                </p>
            </p>
          </template>
          <div class="table-responsive">
            <l-table class="table-hover table-striped"
            :data="linhas" :columns="colunas">
            </l-table>
          </div>
        </card>
        <div class="flex-box-chart col-lg-3 col-sm-4 col-md-4" style="height: 10vw;">

          <!-- <chart-card class="card" :chart-data="retornoGrafico" chart-type="Pie" :key="graficoKey"> -->
          <chart-pie class="card" :chart-data="retornoGrafico" :extraOptions="chartOptions" :key="graficoKey">
            <template slot="header">
              <h4 class="card-title">Pendências</h4>
              <p class="card-category">Últimas pendências</p>
            </template>
            <template slot="footer">
              <!-- <div class="d-inline">
                <p v-for="item in legendaGrafico" :key="item">
                  <i :class="retornaColorGrafico(item)" style="">
                    {{ itemLegenda(item) }}
                  </i>
                </p>
              </div> -->
              <!-- <div class="stats">
                <i class="fa fa-clock-o text-center"></i><span class="time-stamp-subtitle">Enviado há 2 dias atrás.</span>
              </div> -->
            </template>
          </chart-pie>
        </div>
      </div>
  </div>
</template>
<script>
import ChartPie from "../components/Cards/Charts/ChartPie.vue";
import StatsCard from "../components/Cards/StatsCard.vue";
import LTable from "../components/Table.vue";
import { Datas } from "../lib/Helper/index";

export default {
  components: {
    LTable,
    ChartPie,
    StatsCard,
  },
  data() {
    return {
      comunicacao: null,
      cliente: "",
      intervaloConsulta: null,
      retornoLinhas: [],
      tokenApi: "",
      graficoKey: 0,
      // legendaGrafico: [],
      lstData: [],
      ultimoSyncLojas: '00/00/0000 00:00:00',
      editTooltip: "Edit Task",
      deleteTooltip: "Remove",
      chartOptions: {
        animation: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            padding: 10,
          },
        },
      },
      pieChartData: {
        labels: ["0%"],
        datasets: [{
          backgroundColor: ['#1DC7EA', '#FB404B', '#FFA534', '#9368E9', '#87CB16', '#1F77D0'],
          data: [0]
        }],
      },
    };
  },
  computed: {
    colunas() {
      let colunas = this.lstData.length ? Object.keys(this.lstData[0]) : [];

      colunas = colunas.filter((colunaNome) => {
        if(!colunaNome.match(/_S/)){
          return colunaNome
        }
      });

      return colunas;
    },
    retornoGrafico(){
      let colunas = this.lstData.length ? Object.keys(this.lstData[0]) : [];
      let colgrafico = this.lstData.length ? Object.keys(this.lstData[0]) : [];
      colunas = colunas.filter((colunaNome) => {
        if(!colunaNome.match(/Coligada/) && !colunaNome.match(/_S/)){
          return colunaNome;
        }
      });

      colgrafico = colunas.filter((colunaNome) => {
        if(!colunaNome.match(/Coligada/) && !colunaNome.match(/_S/)){
          return colunaNome;
        }
      });

      colunas.push('total');

      let quatidade = this.lstData.map((objeto) => {
        let retorno = {}
        let somaTotal = 0;
        for(let coluna of colunas){
          if(coluna == 'total'){
             retorno[coluna] = somaTotal;
             somaTotal = 0;
          }else if(!retorno[coluna]){
            retorno[coluna] = objeto[coluna];
            somaTotal += objeto[coluna];
          }else{
            retorno[coluna] += objeto[coluna];
            somaTotal += objeto[coluna];
          }
        }
        return retorno;
      });

      let retornoSomatorio = {};
      for(let item of quatidade){
          for(let coluna of colunas){
            if(!retornoSomatorio[coluna]){
              retornoSomatorio[coluna] = 0;
            }
            retornoSomatorio[coluna] += item[coluna];
        }
      }

      let percentualGrafico = [];
      // this.legendaGrafico = [];
      // let index = 0;
      for(let coluna in retornoSomatorio){
        if(coluna != 'total'){
          retornoSomatorio[coluna] = (retornoSomatorio[coluna] / retornoSomatorio['total'] * 100).toFixed(2);
          // this.legendaGrafico.push({
          //   index: index,
          //   valor:`${coluna} (${ retornoSomatorio[coluna] }%)`
          // });
          percentualGrafico.push(retornoSomatorio[coluna]);
          // index++;
        }
      }

      this.pieChartData.labels = colgrafico;
      this.pieChartData.datasets[0].data = percentualGrafico;
      return this.pieChartData;
    },
    linhas(){
      let linha = this.lstData ? this.lstData : [];

      let Status = linha.map((objeto) => {
        let retorno = {}
        for(let coluna of this.colunas){
          retorno[`${coluna}_S`] = objeto[`${coluna}_S`]
        }
        return retorno;
      });


      linha = linha.map((objeto) => {
        let retorno = {}
        for(let coluna of this.colunas){
          const valorStatus = Status[0][`${coluna}_S`];
          const valor = objeto[coluna];
          retorno[coluna] = {
          valor,
          icone: valorStatus ? this.retornaTipoRegistro(valorStatus, valor) : "",
          style: valorStatus ? this.CorTipoRegistro(valorStatus, valor) : "",
          }
        }
        return retorno;
      });
      this.retornoLinhas = [...linha];
      this.graficoPendencias;
      this.graficoKey++;
      return [...linha];
    }
  },
  methods:{
    itemLegenda(item){
      const retorno = item.valor;
      return retorno;
    },
    CorTipoRegistro(tipo, valor) {
        if (!tipo || tipo == "" || valor == 0) {
            return "color:black; text-align:center";
        } else if (tipo == "[U]") {
            return "color:green; text-align:center";
        } else if (tipo == "[D]") {
            return "color:red; text-align:center";
        }
    },
    retornaColorGrafico(item) {
        if (item.index == 0) {
            return "text-left w-100 fa fa-circle ct-serie-a";
        } else if (item.index == 1) {
            return "text-left w-100 fa fa-circle ct-serie-b";
        } else if (item.index == 2) {
            return "text-left w-100 fa fa-circle ct-serie-c";
        } else if (item.index == 3) {
            return "text-left w-100 fa fa-circle ct-serie-d";
        } else if (item.index == 4) {
            return "text-left w-100 fa fa-circle ct-serie-e";
        } else if (item.index == 5) {
            return "text-left w-100 fa fa-circle ct-serie-f";
        } else if (item.index == 6) {
            return "text-left w-100 fa fa-circle ct-serie-g";
        } else if (item.index == 7) {
            return "text-left w-100 fa fa-circle ct-serie-h";
        } else if (item.index == 8) {
            return "text-left w-100 fa fa-circle ct-serie-i";
        } else if (item.index == 9) {
            return "text-left w-100 fa fa-circle ct-serie-j";
        } else if (item.index == 10) {
            return "text-left w-100 fa fa-circle ct-serie-k";
        } else if (item.index == 11) {
            return "text-left w-100 fa fa-circle ct-serie-l";
        } else if (item.index == 12) {
            return "text-left w-100 fa fa-circle ct-serie-m";
        } else if (item.index == 13) {
            return "text-left w-100 fa fa-circle ct-serie-n";
        } else if (item.index == 14) {
            return "text-left w-100 fa fa-circle ct-serie-o";
        }
    },
    retornaTipoRegistro(tipo, valor) {
        if (!tipo || tipo == "" || valor == 0) {
            return "fa fa-minus";
        } else if (tipo == "[U]") {
            return "fa fa-arrow-up";
        } else if (tipo == "[D]") {
            return "fa fa-arrow-down";
        }
    },
    async consultarPendencias(){
        if(localStorage.getItem("bdPendencias")){
          const bd = JSON.parse(localStorage.getItem("bdPendencias"))
          this.ultimoSyncLojas = Datas.formatDateLocale(bd.retorno.ultSync, 'pt-BR');
          this.lstData = bd.retorno.registros[0];
        }

        let r = null;
        try{
          r = await this.comunicacao.send(`v1/${localStorage.getItem('idCliente')}/registrosPendentes`, {
              method: "GET"
          });
        }catch(error){
            console.log(error);
        }

        if(r.status == 200){
          this.ultimoSyncLojas = Datas.formatDateLocale(r.data.retorno.ultSync, 'pt-BR');
          this.lstData = r.data.retorno.registros[0];
          if(!localStorage.getItem("bdPendencias")){
            localStorage.setItem("bdPendencias", JSON.stringify(r.data));
          }else{
             localStorage.setItem("bdPendencias", "{}");
             localStorage.setItem("bdPendencias", JSON.stringify(r.data));
          }
        }
    },
  },
  async created(){
    this.cliente = localStorage.getItem("nomeCliente").toUpperCase();
    this.tokenApi = `basic ${localStorage.getItem('tokenAPI')}`;

    this.comunicacao = await new this.$comunicacao(
      `https://unzlj900u4.execute-api.us-east-1.amazonaws.com/`,
      this.tokenApi
    );

    await this.consultarPendencias();

    this.intervaloConsulta = setInterval(async () => {
      await this.consultarPendencias();
    }, 15000);
  }
};
</script>
<style>
html {
  overflow-x: hidden;
}

.align-subtitle {
  width: 9vh !important;
}

.time-stamp-subtitle {
  font-size: 0.75rem;
}

.card .ct-label{
  display: none;
}

@media screen and (max-width: 500px) {
  .flex-coluna {
    flex-direction: column !important;
    width: 100vh;
  }

  .flex-box {
    display: flex;
    flex-wrap: wrap;
  }

  .flex-box-chart {
    display: flex !important;
    flex-wrap: wrap;
    padding-left: 0px;
  }

  .content {
    padding: 2% 0% 0% 2% !important;
  }

  .card {
    margin-bottom: 5% !important;
    padding: 0px;
    width: fit-content;
  }

  .padding-sm {
    padding-left: 15px;
  }

  .col-sm-4 {
    padding-right: 0px !important;
  }
}

@media screen and (min-width: 700px) {
  .margin-lg {
    margin: 10px 0px 10px 10px;
  }

  .margin-lg-chart {
    margin: 10px 10px 10px 10px;
  }
}

.ct-serie-a  {
  stroke: #1DC7EA;
  fill: #1DC7EA;
  color: #1DC7EA;
}

.ct-serie-b  {
  stroke: #FB404B;
  fill: #FB404B;
  color: #FB404B;
}

.ct-serie-c  {
  stroke: #FFA534;
  fill: #FFA534;
  color: #FFA534;
}

.ct-serie-d  {
  stroke: #9368E9;
  fill: #9368E9;
  color: #9368E9;
}

.ct-serie-e  {
  stroke: #87CB16;
  fill: #87CB16;
  color: #87CB16;
}

.ct-serie-f {
  stroke: #1F77D0;
  fill: #1F77D0;
  color: #1F77D0;
}

.ct-serie-g {
  stroke: #5e5e5e;
  fill: #5e5e5e;
  color: #5e5e5e;
}

.ct-serie-h  {
  stroke: #dd4b39;
  fill: #dd4b39;
  color: #dd4b39;
}

.ct-serie-i {
  stroke: #35465c;
  fill: #35465c;
  color: #35465c;
}

.ct-serie-j {
  stroke: #e52d27;
  fill: #e52d27;
  color: #e52d27;
}

.ct-serie-k {
  stroke: #55acee;
  fill: #55acee;
  color: #55acee;
}

.ct-seris-l{
  stroke: #cc2127;
  fill: #cc2127;
  color: #cc2127;
}

.ct-serie-m{
  fill: #1769ff;
  stroke: #1769ff;
  color: #1769ff;
}

.ct-serie-n {
  fill: #6188e2;
  stroke: #6188e2;
  color: #6188e2;
}

.ct-serie-o {
  fill: #a748ca;
  stroke: #a748ca;
  color: #7B757E
}
</style>
